import React from "react";
import { Breadcrumb as BreadcrumbItem } from "react-bootstrap";

function Breadcrumb({ breadcrumb , title }) { 
  return (
    <div className="breadSec">
      <h1 className="breadSec_title mb-0">{title}</h1>
      <BreadcrumbItem>
      {breadcrumb.map((item, key) => {
        return item.path !== '#' ? (
          <BreadcrumbItem.Item href={item.path} key={key}>{item.name}</BreadcrumbItem.Item>
          ) : (
          <BreadcrumbItem.Item active key={key}>{item.name}</BreadcrumbItem.Item>
          );
        })}
      </BreadcrumbItem>
    </div>
  );
}
  
export default Breadcrumb;